import React from 'react';

import {
  styled,
  ToggleButton as MuiToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup
} from '@mui/material';



const ToggleButton = styled(MuiToggleButton)({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start'
});

const ToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));



export type IViewType = 'order' | 'returnAuthorization';

export interface IProps {
  viewType: IViewType;
  onChangeViewType: (viewType: IViewType) => void;
}

export const FC: React.FC<IProps> = props => (
  <ToggleButtonGroup
    exclusive
    value={props.viewType}
    onChange={(event, value) => {
      if (value) {
        props.onChangeViewType(value);
      }
    }}>
    <ToggleButton
      value="order"
      color="primary">
      Order
    </ToggleButton>

    <ToggleButton
      value="returnAuthorization"
      color="primary">
      Return
    </ToggleButton>
  </ToggleButtonGroup>
);
